// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-icon-view-size[data-v-21f1ab0a] {\n  width: 100px !important;\n  height: 100px !important;\n}\n[data-v-21f1ab0a] .icon-view-extended .dot {\n  width: 42px !important;\n  height: 40px !important;\n}\n@media only screen and (max-width: 768px) {\n.btn-block-xs-only[data-v-21f1ab0a] {\n    display: block;\n    width: 100%;\n    margin-bottom: 20px;\n}\n.custom-status-extended[data-v-21f1ab0a] {\n    width: 100% !important;\n}\n}", ""]);
// Exports
module.exports = exports;
